var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSignUpImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1247,
    height: 1075,
    viewBox: "0 0 1247 1075",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_16353)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1247,
    height: 1075,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1256.55 0H0V1075H1256.55V0Z",
    fill: "url(#paint0_linear_13_16353)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M1324.01 265.124C1328.32 257.007 1330.23 248.206 1329.61 239.403C1328.98 230.6 1325.83 222.03 1320.39 214.356C1325.55 200.35 1323.84 185.3 1315.6 172.267C1307.37 159.234 1293.24 149.198 1276.08 144.198C1258.92 139.199 1240.02 139.613 1223.22 145.356C1206.43 151.098 1193.01 161.738 1185.68 175.112C1179.64 168.536 1171.26 163.56 1161.64 160.83C1152.02 158.099 1141.6 157.738 1131.72 159.794C1121.84 161.85 1112.96 166.228 1106.23 172.362C1099.5 178.496 1095.23 186.104 1093.96 194.201H1093.52C1081.67 194.174 1070.17 197.46 1061.03 203.491C1058.8 199.293 1055.41 195.556 1051.1 192.567C1046.79 189.577 1041.68 187.413 1036.17 186.241C1030.66 185.068 1024.88 184.917 1019.28 185.799C1013.68 186.682 1008.41 188.574 1003.87 191.332C992.637 182.306 978.78 175.646 963.539 171.952C948.298 168.257 932.148 167.642 916.536 170.162C905.69 158.087 890.711 148.773 873.401 143.34C856.091 137.906 837.186 136.585 818.959 139.534C800.732 142.483 783.958 149.578 770.655 159.965C757.351 170.351 748.084 183.589 743.967 198.085C733.028 190.964 719.711 186.572 705.673 185.458C691.634 184.343 677.496 186.554 665.018 191.815C658.738 184.221 650.289 177.93 640.367 173.461C630.445 168.993 619.335 166.475 607.956 166.115C596.576 165.756 585.253 167.565 574.92 171.393C564.588 175.222 555.543 180.96 548.533 188.134C537.991 182.615 525.804 179.435 513.219 178.919C510.73 172.784 506.455 167.209 500.747 162.651C495.038 158.093 488.057 154.683 480.379 152.701C472.7 150.718 464.543 150.221 456.578 151.248C448.612 152.276 441.065 154.8 434.556 158.612C424.998 149.707 412.256 143.358 398.045 140.419C383.835 137.48 368.839 138.094 355.077 142.176C341.316 146.258 329.45 153.614 321.079 163.252C312.708 172.889 308.233 184.346 308.258 196.079C294.075 197.873 280.888 203.019 270.395 210.854C259.902 218.689 252.583 228.856 249.38 240.045C238.903 235.473 227.169 233.057 215.233 233.012C203.298 232.968 191.536 235.297 181.007 239.791C178.792 232.463 173.943 225.812 167.058 220.66C160.173 215.507 151.552 212.077 142.258 210.793C132.965 209.509 123.404 210.426 114.754 213.431C106.104 216.437 98.7434 221.4 93.5789 227.708C80.7294 220.31 65.1815 216.513 49.3532 216.908C33.5249 217.302 18.3035 221.867 6.05598 229.891C4.14869 227.589 2.1279 225.356 0 223.196V348.029C6.97899 340.96 12.7785 333.138 17.2028 324.752C27.9863 329.443 40.0944 331.845 52.3704 331.729C64.6464 331.614 76.6804 328.984 87.3227 324.092C91.4715 332.647 98.1259 340.282 106.728 346.358C115.33 352.433 125.629 356.771 136.761 359.009C147.893 361.247 159.534 361.318 170.709 359.218C181.883 357.118 192.264 352.906 200.982 346.938C218.987 349.739 237.651 346.913 253.127 339.043C260.765 346.928 270.843 353.085 282.366 356.907C293.889 360.729 306.46 362.085 318.838 360.839C331.217 359.594 342.975 355.791 352.953 349.805C362.932 343.82 370.786 335.858 375.742 326.706C391.076 332.325 408.397 333.443 424.661 329.864C440.924 326.284 455.088 318.236 464.662 307.135C467.816 318.579 475.275 328.978 486.038 336.935C496.801 344.892 510.352 350.027 524.872 351.649C539.391 353.271 554.184 351.303 567.264 346.009C580.344 340.716 591.084 332.35 598.043 322.036C606.389 329.372 616.969 334.857 628.753 337.956C640.537 341.056 653.125 341.664 665.29 339.721C677.456 337.779 688.785 333.353 698.176 326.873C707.567 320.393 714.699 312.08 718.879 302.744C722.138 312.892 728.811 322.134 738.174 329.467C747.536 336.8 759.232 341.945 771.992 344.343C784.752 346.741 798.091 346.302 810.561 343.072C823.03 339.842 834.156 333.945 842.732 326.021C849.578 332.764 858.249 338.178 868.092 341.854C877.936 345.53 888.694 347.372 899.557 347.243C910.42 347.113 921.105 345.015 930.807 341.106C940.509 337.197 948.974 331.579 955.565 324.676C966.135 328.343 977.662 329.901 989.153 329.215C1000.64 328.53 1011.75 325.622 1021.53 320.741C1025.25 333.512 1032.99 345.314 1044 355.032C1055.02 364.75 1068.95 372.066 1084.48 376.287C1100.02 380.509 1116.64 381.498 1132.78 379.161C1148.93 376.824 1164.06 371.238 1176.75 362.93C1193.99 375.456 1216.31 382.578 1239.61 382.982C1262.9 383.385 1285.59 377.043 1303.49 365.126C1321.39 353.208 1333.29 336.518 1337.01 318.135C1340.72 299.752 1335.99 280.915 1323.7 265.099L1324.01 265.124Z",
    fill: "url(#paint1_linear_13_16353)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1272.19 98C1216.26 63.6475 1170.05 56.3149 1139.69 55.3104C1053.5 52.7993 1013.48 99.5067 932.563 86.5994C883.965 78.8399 892.316 61.061 840.673 48.9321C736.632 24.4986 689.671 93.5804 592.77 70.2518C539.195 57.3194 522.624 28.7676 458.143 27.6878C426.836 27.1353 418.846 33.6392 391.894 30.9523C330.492 24.7748 261.056 18.3019 264.331 1.00005L1338.24 1L1272.19 98Z",
    fill: "url(#paint2_linear_13_16353)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1328.16 438.572C1224.05 370.656 1146.02 365.781 1093.88 373.982C957.223 395.461 862.658 528.196 782.556 486.583C763.272 476.427 732.321 449.845 683.507 448.499C660.173 447.839 657.811 453.577 636.333 451.8C584.217 447.306 574.358 410.974 535.79 407.089C494.811 402.976 484.494 441.949 432.137 456.776C378.647 472.01 335.716 446.62 301.631 435.246C243.609 416.077 151.985 418.337 6.05103 516.492C130.049 477.494 222.42 484.476 284.13 498.186C357.579 514.511 398.679 542.947 497.969 549.523C580.65 555.007 584.073 537.412 645.758 546.197C775.662 564.731 789.595 646.916 869.022 643.92C976.194 639.883 995.768 488.716 1136.33 445.173C1208.91 422.704 1278.4 439.842 1326.59 458.426",
    fill: "url(#paint3_linear_13_16353)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1328.16 958.251C1204.74 907.881 1128.63 913.644 1081.32 929.689C1053.88 938.981 1037.35 951.269 1000.06 955.636C931.848 963.684 901.765 932.634 840.646 921.895C725.274 901.584 683.208 986.102 584.395 969.93C494.787 955.255 489.978 879.319 401.579 831.03C336.243 795.334 220.382 772.104 0 842.709C208.709 754.688 337.966 753.85 418.755 771.317C458.429 779.898 510.677 798.152 585.886 790.79C660.607 783.478 684.468 758.115 757.749 760.933C823.444 763.472 826.17 784.646 882.763 785.585C967.846 787.007 998.624 739.658 1073.4 723.282C1124.2 712.137 1202.7 713.686 1318.72 777.791L1328.16 958.251Z",
    fill: "url(#paint4_linear_13_16353)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M751.484 171.066C756.947 165.691 848.766 95.2329 848.766 95.2329C848.766 95.2329 776.73 185.137 771.318 190.512C768.682 193.075 765.115 194.509 761.401 194.501C757.686 194.493 754.126 193.044 751.501 190.47C748.876 187.896 747.4 184.409 747.397 180.772C747.394 177.134 748.863 173.644 751.484 171.066Z",
    fill: "url(#paint5_linear_13_16353)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M1148.7 397.833C1154.16 392.458 1245.98 322 1245.98 322C1245.98 322 1173.95 411.904 1168.54 417.279C1165.9 419.842 1162.33 421.276 1158.62 421.268C1154.9 421.26 1151.34 419.811 1148.72 417.237C1146.09 414.664 1144.62 411.176 1144.61 407.539C1144.61 403.901 1146.08 400.411 1148.7 397.833Z",
    fill: "url(#paint6_linear_13_16353)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M107.924 530.794C113.387 525.419 205.206 454.961 205.206 454.961C205.206 454.961 133.248 544.865 127.758 550.215C126.474 551.567 124.925 552.652 123.203 553.405C121.481 554.158 119.621 554.563 117.736 554.596C115.85 554.63 113.977 554.291 112.228 553.6C110.48 552.909 108.891 551.879 107.558 550.574C106.224 549.268 105.173 547.713 104.467 546C103.761 544.288 103.415 542.454 103.449 540.608C103.484 538.762 103.897 536.941 104.666 535.255C105.435 533.569 106.543 532.052 107.924 530.794Z",
    fill: "url(#paint7_linear_13_16353)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M294.898 155.634C297.488 153.099 340.393 120.139 340.393 120.139C340.393 120.139 306.732 162.175 304.142 164.685C303.534 165.281 302.811 165.754 302.016 166.077C301.221 166.399 300.368 166.565 299.507 166.565C298.647 166.565 297.794 166.399 296.999 166.077C296.204 165.754 295.481 165.281 294.872 164.685C294.264 164.089 293.781 163.382 293.452 162.603C293.122 161.824 292.953 160.99 292.953 160.147C292.953 159.304 293.122 158.469 293.452 157.691C293.781 156.912 294.264 156.205 294.872 155.609L294.898 155.634Z",
    fill: "url(#paint8_linear_13_16353)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M584.698 934.35C587.287 931.814 630.219 898.854 630.219 898.854C630.219 898.854 596.557 940.916 593.968 943.426C592.721 944.566 591.071 945.187 589.366 945.159C587.661 945.13 586.034 944.454 584.828 943.273C583.622 942.093 582.932 940.499 582.903 938.83C582.874 937.16 583.508 935.545 584.672 934.324L584.698 934.35Z",
    fill: "url(#paint9_linear_13_16353)"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M300.359 174.235C296.274 186.154 289.829 197.167 281.393 206.645C272.956 216.123 262.694 223.879 251.193 229.469C239.693 235.06 227.179 238.375 214.368 239.225C201.558 240.076 188.702 238.444 176.536 234.425C172.954 233.253 169.444 231.882 166.023 230.317C146.204 221.186 130.094 205.798 120.279 186.624C110.465 167.451 107.516 145.604 111.905 124.592C112.692 120.745 113.73 116.951 115.012 113.234C118.997 101.189 125.382 90.0378 133.798 80.4257C142.214 70.8135 152.493 62.9314 164.041 57.2354C175.589 51.5395 188.176 48.143 201.074 47.2425C213.972 46.342 226.924 47.9553 239.18 51.9892C251.437 56.0231 262.754 62.3973 272.478 70.7429C282.202 79.0886 290.138 89.2398 295.828 100.609C301.518 111.978 304.848 124.34 305.626 136.978C306.403 149.615 304.613 162.279 300.359 174.235Z",
    fill: "url(#paint10_linear_13_16353)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M281.942 81.4404C270.42 96.8301 252.942 116.353 233.521 123.198C204.521 133.34 149.989 137.396 113.997 171.091C109.39 156.015 108.678 140.055 111.925 124.643C194.163 103.828 239.114 79.6656 261.694 63.9463C269.236 68.8341 276.05 74.7214 281.942 81.4404Z",
    fill: "url(#paint11_linear_13_16353)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M305.349 138.41C293.188 145.399 281.416 153.016 270.081 161.229C243.566 180.497 229.921 207.702 208.273 239.47C197.487 239.509 186.768 237.796 176.554 234.399C172.972 233.228 169.462 231.857 166.041 230.292C201.722 179.585 264.022 134.252 299.522 110.825C302.839 119.69 304.802 128.985 305.349 138.41Z",
    fill: "url(#paint12_linear_13_16353)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6,
    d: "M1085.04 584.303C1088.58 574.175 1096.06 565.826 1105.86 561.077C1115.66 556.328 1126.97 555.563 1137.34 558.949C1138.86 559.444 1140.35 560.029 1141.8 560.699C1150.17 564.552 1156.98 571.05 1161.12 579.147C1165.27 587.245 1166.52 596.472 1164.66 605.347C1164.32 606.977 1163.88 608.586 1163.34 610.164C1161.01 616.943 1156.89 622.996 1151.39 627.705C1145.89 632.413 1139.22 635.609 1132.05 636.965C1124.87 638.321 1117.46 637.789 1110.57 635.423C1103.67 633.058 1097.55 628.943 1092.81 623.5C1089.6 619.822 1087.08 615.616 1085.38 611.077C1083.97 607.33 1083.14 603.4 1082.92 599.414C1082.64 594.291 1083.36 589.163 1085.04 584.303Z",
    fill: "url(#paint13_radial_13_16353)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M1080.48 582.807C1082.41 577.18 1085.45 571.979 1089.43 567.503C1093.41 563.027 1098.25 559.363 1103.68 556.721C1109.11 554.079 1115.01 552.51 1121.06 552.105C1127.11 551.7 1133.18 552.467 1138.92 554.36C1140.61 554.928 1142.27 555.579 1143.9 556.313C1153.24 560.633 1160.84 567.902 1165.47 576.953C1170.1 586.005 1171.49 596.316 1169.43 606.234C1169.06 608.048 1168.57 609.836 1167.95 611.584C1164.54 621.551 1157.68 630.04 1148.57 635.591C1139.45 641.143 1128.64 643.407 1118.01 641.996C1107.37 640.585 1097.56 635.586 1090.29 627.86C1083.01 620.133 1078.71 610.164 1078.13 599.668C1077.8 593.952 1078.6 588.228 1080.48 582.807Z",
    fill: "url(#paint14_radial_13_16353)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M1089.93 585.926C1093.03 577.055 1099.58 569.743 1108.17 565.587C1116.75 561.43 1126.66 560.767 1135.74 563.741C1137.09 564.198 1138.38 564.705 1139.62 565.263C1144.23 567.381 1148.33 570.431 1151.64 574.211C1154.96 577.991 1157.42 582.415 1158.86 587.194C1160.59 592.77 1160.85 598.68 1159.64 604.383C1159.35 605.799 1158.97 607.196 1158.5 608.567C1155.43 617.456 1148.88 624.792 1140.3 628.969C1131.71 633.145 1121.79 633.822 1112.7 630.853C1109.72 629.866 1106.88 628.511 1104.25 626.821C1101.46 625.01 1098.94 622.825 1096.77 620.331C1091.58 614.429 1088.53 607.013 1088.1 599.237C1087.84 594.726 1088.46 590.208 1089.93 585.926Z",
    fill: "url(#paint15_radial_13_16353)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1143.48 611.178C1140.5 615.102 1136.34 618.015 1131.59 619.51C1126.83 621.006 1121.72 621.009 1116.96 619.52C1113.56 618.533 1110.44 616.798 1107.82 614.449C1103.9 610.857 1101.32 606.074 1100.51 600.872C1099.69 595.67 1100.69 590.352 1103.34 585.774C1103.82 584.932 1104.35 584.127 1104.95 583.365C1108.73 578.36 1114.39 575.029 1120.68 574.107C1126.96 573.184 1133.37 574.746 1138.48 578.447C1140.15 579.666 1141.66 581.089 1142.96 582.681C1144.35 584.387 1145.49 586.272 1146.35 588.284C1148.39 593.045 1148.76 598.329 1147.42 603.319C1146.62 606.159 1145.29 608.826 1143.48 611.178Z",
    fill: "url(#paint16_linear_13_16353)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1146.35 588.157C1142.49 590.896 1136.88 594.141 1131.83 594.318C1124.27 594.547 1111.24 591.428 1100.24 596.651C1100.32 592.787 1101.39 589.006 1103.34 585.647C1124.06 586.864 1136.49 584.557 1142.96 582.554C1144.35 584.26 1145.49 586.146 1146.35 588.157Z",
    fill: "url(#paint17_linear_13_16353)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1147.41 603.192C1144.03 603.91 1140.7 604.807 1137.42 605.879C1129.65 608.415 1124.47 613.764 1116.96 619.57C1113.56 618.569 1110.43 616.817 1107.82 614.449C1120.04 605.246 1138.09 599.237 1148.19 596.448C1148.25 598.72 1147.99 600.99 1147.41 603.192Z",
    fill: "url(#paint18_linear_13_16353)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M394.221 422.129C398.286 418.149 584.409 240.343 587.18 243.03C589.95 245.718 408.281 427.935 404.19 431.916C400.099 435.896 394.583 436.987 391.813 434.274C389.042 431.561 390.13 426.135 394.221 422.129Z",
    fill: "url(#paint19_linear_13_16353)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M60.8247 114.941C56.6299 118.947 51.1923 120.012 48.4476 117.274C45.7028 114.535 46.8939 109.16 50.8298 105.155C53.0764 102.969 110.233 48.3554 161.744 0H174.366C123.628 51.9772 63.2256 112.648 60.8247 114.941Z",
    fill: "url(#paint20_linear_13_16353)"
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04224 593.759C67.7824 663.533 111.206 673.548 139.43 669.238C169.078 664.699 184.718 644.087 219.7 649.107C250.772 653.569 255.951 672.28 289.613 677.909C320.374 682.979 327.806 669.314 362.115 666.398C426.849 660.896 435.782 706.736 497.383 702.679C534.204 700.144 543.344 683.081 599.093 679.658C615.393 678.651 631.752 679.05 647.98 680.85C603.262 652.555 564.784 642.819 537.622 639.422C480.941 632.145 458.31 649.563 403.26 633.945C361.985 622.206 363.435 609.175 325.165 601.999C279.333 593.43 271.254 611.025 218.172 607.932C165.531 604.864 156.028 586.559 104.551 581.894C70.8998 579.029 37.0079 583.07 5.04224 593.759Z",
    fill: "url(#paint21_linear_13_16353)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04224 593.759C67.7824 663.533 111.206 673.548 139.43 669.238C169.078 664.699 184.718 644.087 219.7 649.107C250.772 653.569 255.951 672.28 289.613 677.909C320.374 682.979 327.806 669.314 362.115 666.398C426.849 660.896 435.782 706.736 497.383 702.679C534.204 700.144 543.344 683.081 599.093 679.658C615.393 678.651 631.752 679.05 647.98 680.85C603.262 652.555 564.784 642.819 537.622 639.422C480.941 632.145 458.31 649.563 403.26 633.945C361.985 622.206 363.435 609.175 325.165 601.999C279.333 593.43 271.254 611.025 218.172 607.932C165.531 604.864 156.028 586.559 104.551 581.894C70.8998 579.029 37.0079 583.07 5.04224 593.759Z",
    fill: "url(#paint22_linear_13_16353)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1016.2C99.5559 963.253 157.948 962.111 193.086 971.516C229.921 981.327 244.37 1003.44 290.69 1005.37C331.662 1007.08 343.566 990.688 388.294 991.844C429.181 992.881 434.974 1007.03 478.153 1016.21C559.631 1033.55 583.735 992.686 661.733 1008.09C708.413 1017.31 715.394 1034.99 786.029 1048.65C806.69 1052.65 827.804 1055.37 849.132 1056.78C783.971 1074.61 731.965 1076.31 696.149 1074.37C621.376 1070.44 597.06 1049.94 522.159 1054.08C465.952 1057.17 464.255 1069.55 413.161 1068.96C351.968 1068.26 346.409 1050.39 277.365 1043.24C208.936 1036.14 191.94 1051.37 124.402 1045.95C80.4677 1042.26 38.1005 1032.12 0 1016.2Z",
    fill: "url(#paint23_linear_13_16353)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M643.554 300.733L644.512 304.638L648.526 305.601L644.512 306.565L643.554 310.469L642.57 306.565L638.583 305.601L642.57 304.638L643.554 300.733Z",
    fill: "#714268"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M582.24 850.251L583.224 854.156L587.212 855.119L583.224 856.083L582.24 859.987L581.256 856.083L577.269 855.119L581.256 854.156L582.24 850.251Z",
    fill: "#714268"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M643.814 112.735L644.798 116.64L648.786 117.603L644.798 118.567L643.814 122.471L642.83 118.567L638.843 117.603L642.83 116.64L643.814 112.735Z",
    fill: "#714268"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M187.647 31.8315L188.631 35.736L192.618 36.6995L188.631 37.6629L187.647 41.5674L186.663 37.6629L182.675 36.6995L186.663 35.736L187.647 31.8315Z",
    fill: "#714268"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M925.356 86.1899L927.376 94.2524L935.61 96.23L927.376 98.2076L925.356 106.27L923.337 98.2076L915.103 96.23L923.337 94.2524L925.356 86.1899Z",
    fill: "#714268"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M330.995 206.291L333.04 214.354L341.248 216.331L333.04 218.309L330.995 226.371L328.975 218.309L320.741 216.331L328.975 214.354L330.995 206.291Z",
    fill: "#714268"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M204.765 368.53L205.749 372.434L209.737 373.398L205.749 374.361L204.765 378.266L203.781 374.361L199.793 373.398L203.781 372.434L204.765 368.53Z",
    fill: "#714268"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M115.354 316.706L116.338 320.611L120.325 321.574L116.338 322.537L115.354 326.442L114.37 322.537L110.382 321.574L114.37 320.611L115.354 316.706Z",
    fill: "#714268"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M801.896 501.865L802.88 505.77L806.867 506.733L802.88 507.697L801.896 511.626L800.912 507.697L796.924 506.733L800.912 505.77L801.896 501.865Z",
    fill: "#714268"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M847.245 537.816H777.281V867.314H847.245V537.816Z",
    fill: "url(#paint24_linear_13_16353)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M832.199 537.816H792.323V1058.38H832.199V537.816Z",
    fill: "url(#paint25_linear_13_16353)"
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M815.862 690.066C814.464 693.438 812.988 696.835 811.408 700.208C784.116 639.688 780.672 593.265 782.019 566.695C782.174 563.323 782.407 560.28 782.692 557.567C783.132 553.333 783.676 549.961 784.142 547.426C784.475 545.487 784.907 543.566 785.437 541.67V542.634L802.475 542.33L821.74 541.949L832.097 541.746H837.276C837.276 541.746 837.846 543.699 838.571 547.502C839.037 550.037 839.58 553.46 839.995 557.643C840.331 560.66 840.59 564.134 840.772 567.988C842.04 593.189 838.804 635.429 815.862 690.066Z",
    fill: "url(#paint26_linear_13_16353)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M813.891 648.029C813.14 650.438 812.311 652.897 811.483 655.356C796.568 612.001 794.704 578.737 795.429 559.697C795.429 557.161 795.662 555.082 795.817 553.13C796.05 550.113 796.335 547.679 796.594 545.828C796.982 543.115 797.293 541.721 797.293 541.721V542.405L806.589 542.177L817.102 541.924L822.798 541.771H825.673C825.673 541.771 825.983 543.166 826.372 545.879C826.631 547.73 826.915 550.164 827.149 553.181C827.33 555.361 827.485 557.846 827.563 560.609C828.158 578.61 826.372 608.883 813.891 648.029Z",
    fill: "url(#paint27_linear_13_16353)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M930.103 504.603L856.41 482.52V372.611L930.103 436.376V504.603Z",
    fill: "#F1F2F2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M925.729 505.161C925.729 507.945 926.858 510.615 928.869 512.583C930.879 514.552 933.606 515.657 936.449 515.657C937.859 515.661 939.256 515.392 940.559 514.866C941.863 514.34 943.048 513.567 944.046 512.592C945.044 511.617 945.836 510.459 946.376 509.184C946.917 507.909 947.195 506.542 947.195 505.161V428.821H925.729V505.161Z",
    fill: "#E6E7E8"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M930.34 418.499L925.161 428.64H946.627L941.448 418.499C940.912 417.512 940.112 416.687 939.133 416.112C938.155 415.537 937.035 415.233 935.894 415.233C934.753 415.233 933.633 415.537 932.655 416.112C931.676 416.687 930.876 417.512 930.34 418.499Z",
    fill: "url(#paint28_linear_13_16353)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M949.394 512.361H923.552L925.727 507.088H947.219L949.394 512.361Z",
    fill: "#E6E7E8"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M949.394 512.361H923.552V520.398H949.394V512.361Z",
    fill: "url(#paint29_linear_13_16353)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M694.395 504.603L768.114 482.52V372.611L694.395 436.376V504.603Z",
    fill: "#F1F2F2"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M698.77 505.161C698.77 506.542 698.492 507.909 697.952 509.184C697.411 510.459 696.619 511.617 695.621 512.592C694.623 513.567 693.438 514.34 692.134 514.866C690.831 515.392 689.434 515.661 688.024 515.657C685.181 515.657 682.454 514.552 680.444 512.583C678.434 510.615 677.304 507.945 677.304 505.161V428.821H698.77V505.161Z",
    fill: "#E6E7E8"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M693.229 418.499L698.408 428.64H676.942L682.121 418.499C682.657 417.512 683.457 416.687 684.435 416.112C685.414 415.537 686.534 415.233 687.675 415.233C688.816 415.233 689.936 415.537 690.914 416.112C691.893 416.687 692.693 417.512 693.229 418.499Z",
    fill: "url(#paint30_linear_13_16353)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M675.13 512.361H700.971L698.771 507.088H677.305L675.13 512.361Z",
    fill: "#E6E7E8"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M674.667 520.269H700.509V512.231H674.667V520.269Z",
    fill: "url(#paint31_linear_13_16353)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M851.464 241.989L823.447 188.746C822.391 186.728 820.786 185.035 818.81 183.852C816.835 182.67 814.564 182.044 812.248 182.044C809.932 182.044 807.662 182.67 805.686 183.852C803.71 185.035 802.105 186.728 801.049 188.746L773.006 241.989C771.53 244.829 770.132 247.719 768.786 250.609H855.71C854.364 247.719 852.966 244.829 851.464 241.989Z",
    fill: "url(#paint32_linear_13_16353)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M768.784 250.559C756.642 276.581 750.355 304.856 750.348 333.465V496.11H874.145V333.516C874.145 304.889 867.858 276.597 855.709 250.559H768.784Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M793.849 250.558C794.419 247.668 795.014 244.778 795.636 241.938L807.495 188.695C808.505 184.233 810.369 182.002 812.233 182.002C809.917 181.986 807.642 182.604 805.666 183.787C803.689 184.97 802.09 186.67 801.047 188.695L773.005 241.938C771.529 244.778 770.13 247.668 768.784 250.558C756.642 276.581 750.355 304.855 750.348 333.465V496.11H786.055V333.516C785.977 305.685 788.586 277.909 793.849 250.558Z",
    fill: "#F1F2F2"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M855.71 250.558C854.363 247.668 852.965 244.778 851.463 241.938L823.446 188.695C822.383 186.689 820.772 185.01 818.793 183.846C816.813 182.682 814.543 182.079 812.234 182.103C814.125 182.103 815.989 184.334 816.973 188.797L828.832 242.04C829.479 244.879 830.075 247.77 830.645 250.66C835.895 277.994 838.496 305.753 838.413 333.567V496.211H874.12V333.516C874.128 304.891 867.85 276.599 855.71 250.558Z",
    fill: "#F1F2F2"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M879.581 496.233H743.743C740.125 496.233 737.192 499.105 737.192 502.647V502.673C737.192 506.215 740.125 509.087 743.743 509.087H879.581C883.199 509.087 886.132 506.215 886.132 502.673V502.647C886.132 499.105 883.199 496.233 879.581 496.233Z",
    fill: "url(#paint33_linear_13_16353)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M860.577 530.768H763.942L768.733 517.965L772.099 509.015H852.395L855.761 517.965L860.577 530.768Z",
    fill: "#E6E7E8"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M855.765 517.965H768.736L772.103 509.015H852.399L855.765 517.965Z",
    fill: "#CECECE"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M860.577 530.769H763.942V544.865H860.577V530.769Z",
    fill: "url(#paint34_linear_13_16353)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M783.308 250.558C784.189 247.668 785.121 244.778 786.131 241.938L804.774 188.695C806.354 184.233 809.305 182.002 812.231 182.002C809.915 181.986 807.64 182.604 805.664 183.787C803.687 184.97 802.088 186.67 801.045 188.695L773.003 241.938C771.527 244.778 770.128 247.668 768.782 250.558C756.64 276.581 750.353 304.855 750.346 333.465V496.11H771.061V333.516C770.967 305.425 775.094 277.473 783.308 250.558Z",
    fill: "#F1F2F2"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M855.708 250.558C854.361 247.668 852.963 244.778 851.461 241.938L823.444 188.695C822.381 186.689 820.77 185.01 818.791 183.846C816.811 182.682 814.541 182.079 812.232 182.103C815.184 182.103 818.136 184.334 819.69 188.797L838.359 242.04C839.343 244.879 840.275 247.77 841.181 250.66C849.399 277.557 853.535 305.491 853.455 333.567V496.211H874.17V333.516C874.162 304.887 867.866 276.595 855.708 250.558Z",
    fill: "#F1F2F2"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M812.26 306.464C816.52 306.447 820.742 307.255 824.682 308.84C828.623 310.426 832.204 312.758 835.222 315.703C838.239 318.648 840.632 322.147 842.264 326C843.896 329.854 844.734 333.984 844.731 338.156V383.032C844.731 384.424 844.166 385.759 843.161 386.743C842.156 387.727 840.792 388.28 839.371 388.28H785.175C783.754 388.28 782.391 387.727 781.385 386.743C780.38 385.759 779.815 384.424 779.815 383.032V338.156C779.815 329.757 783.223 321.703 789.288 315.764C795.353 309.825 803.579 306.489 812.157 306.489L812.26 306.464Z",
    fill: "url(#paint35_linear_13_16353)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M839.166 390.841H785.256C783.141 390.841 781.112 390.018 779.617 388.554C778.121 387.089 777.281 385.103 777.281 383.032V338.131C777.629 329.281 781.464 320.907 787.981 314.766C794.499 308.626 803.192 305.195 812.237 305.195C821.282 305.195 829.975 308.626 836.493 314.766C843.01 320.907 846.846 329.281 847.193 338.131V383.032C847.193 384.062 846.985 385.081 846.581 386.032C846.177 386.983 845.585 387.846 844.839 388.572C844.093 389.298 843.208 389.872 842.234 390.261C841.261 390.651 840.218 390.848 839.166 390.841ZM812.237 309.05C804.362 309.057 796.812 312.123 791.244 317.575C785.675 323.027 782.544 330.42 782.537 338.131V383.032C782.519 383.387 782.576 383.741 782.706 384.072C782.836 384.403 783.036 384.704 783.292 384.955C783.548 385.206 783.856 385.401 784.194 385.529C784.532 385.656 784.894 385.712 785.256 385.694H839.166C839.528 385.712 839.89 385.656 840.228 385.529C840.567 385.401 840.874 385.206 841.13 384.955C841.387 384.704 841.586 384.403 841.716 384.072C841.846 383.741 841.904 383.387 841.885 383.032V338.131C841.878 330.429 838.754 323.043 833.197 317.593C827.64 312.142 820.103 309.07 812.237 309.05Z",
    fill: "#A5B7C6"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M812.882 333.338C812.882 339.854 808.247 345.128 802.525 345.128C796.802 345.128 792.167 339.854 792.167 333.338C792.167 326.822 796.777 321.549 802.525 321.549C808.273 321.549 812.882 326.822 812.882 333.338Z",
    fill: "#7281F2"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M479.683 886.446L479.429 886.169C472.756 879.745 411.083 900.426 340.387 932.897C268.832 965.796 214.817 998.317 220.219 1005.57C220.35 1005.74 220.511 1005.89 220.695 1006.02C228.48 1011.82 289.581 991.238 359.515 959.12C431.164 926.221 484.894 893.776 479.683 886.446ZM357.545 956.4C295.014 985.117 240.776 1004.14 233.977 999.878C233.779 999.776 233.616 999.638 233.5 999.475C229.306 993.732 277.983 965.141 342.357 935.592C405.904 906.497 460.65 887.353 466.274 892.315L466.497 892.542C470.595 898.285 421.855 926.876 357.545 956.4Z",
    fill: "url(#paint36_linear_13_16353)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M394.344 967.04C392.264 973.117 388.979 978.733 384.677 983.564C380.376 988.395 375.142 992.347 369.277 995.192C363.411 998.038 357.03 999.722 350.498 1000.15C343.966 1000.57 337.413 999.728 331.215 997.667C329.392 997.069 327.603 996.375 325.855 995.588C314.42 990.249 305.494 980.842 300.894 969.285C296.293 957.727 296.365 944.887 301.095 933.379C305.824 921.872 314.856 912.562 326.35 907.345C337.844 902.129 350.936 901.399 362.961 905.303C367.064 906.637 370.966 908.505 374.561 910.856C378.426 913.338 381.913 916.342 384.919 919.78C388.791 924.204 391.825 929.27 393.878 934.739C395.551 939.265 396.545 944.005 396.83 948.81C397.192 954.986 396.348 961.173 394.344 967.04Z",
    fill: "url(#paint37_linear_13_16353)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M384.964 919.78C379.138 927.614 370.179 937.528 360.314 941.026C345.528 946.097 317.77 948.227 299.438 965.391C297.1 957.712 296.735 949.587 298.376 941.736C340.246 931.138 363.11 918.918 374.633 910.855C378.488 913.339 381.966 916.344 384.964 919.78Z",
    fill: "url(#paint38_linear_13_16353)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M396.877 948.811C390.682 952.349 384.683 956.208 378.907 960.372C365.417 970.209 358.477 984.052 347.447 1000.23C341.954 1000.27 336.494 999.409 331.289 997.693C329.466 997.094 327.676 996.4 325.929 995.614C344.054 969.778 375.826 946.706 393.926 934.765C395.596 939.283 396.59 944.014 396.877 948.811Z",
    fill: "url(#paint39_linear_13_16353)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M359.589 959.053C289.73 991.216 228.635 1011.83 220.855 1006.02L234.128 999.868C240.924 1004.13 295.128 985.086 357.62 956.329C421.891 926.765 470.601 898.134 466.41 892.382L466.187 892.155L479.429 886L479.683 886.277C484.891 893.618 431.194 926.109 359.589 959.053Z",
    fill: "url(#paint40_linear_13_16353)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13_16353",
    x1: 628.277,
    y1: 327.5,
    x2: 628.277,
    y2: 1619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5280F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#011B77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13_16353",
    x1: 669.229,
    y1: -89.498,
    x2: 669.229,
    y2: 357.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A87FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001338"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13_16353",
    x1: 801.142,
    y1: -41.819,
    x2: 801.142,
    y2: 177.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F80FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0028B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_13_16353",
    x1: 666.995,
    y1: 250.489,
    x2: 666.995,
    y2: 866.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F80FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0028B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_13_16353",
    x1: 663.969,
    y1: 605.876,
    x2: 663.969,
    y2: 1179.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5280F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#011B77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_13_16353",
    x1: 798.066,
    y1: 94.1681,
    x2: 798.066,
    y2: 196.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#030101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#0E0502"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#1F0C05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#381508"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#58210D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65260F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_13_16353",
    x1: 1195.28,
    y1: 320.935,
    x2: 1195.28,
    y2: 422.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#030101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#0E0502"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#1F0C05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#381508"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#58210D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65260F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_13_16353",
    x1: 154.506,
    y1: 453.896,
    x2: 154.506,
    y2: 555.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#030101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#0E0502"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#1F0C05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#381508"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#58210D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65260F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_13_16353",
    x1: 316.675,
    y1: 119.657,
    x2: 316.675,
    y2: 167.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#030101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#0E0502"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#1F0C05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#381508"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#58210D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65260F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_13_16353",
    x1: 606.5,
    y1: 898.398,
    x2: 606.5,
    y2: 946.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#030101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#0E0502"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#1F0C05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#381508"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#58210D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65260F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_13_16353",
    x1: 230.94,
    y1: 44,
    x2: 116.406,
    y2: 181.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B93DB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.530675,
    stopColor: "#7438D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003F9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_13_16353",
    x1: 271.521,
    y1: 71.382,
    x2: 154.945,
    y2: 136.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B93DB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#7438D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003F9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_13_16353",
    x1: 278.842,
    y1: 138,
    x2: 161.244,
    y2: 201.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B93DB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#7438D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003F9D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_13_16353",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1111.85 589.889) rotate(-161.746) scale(41.2883 40.5983)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#020101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#090305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#14070B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#250C14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#3B1420"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#571C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#772740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#9D3454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#C6416A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D84774"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_13_16353",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1111.85 589.889) rotate(-161.746) scale(46.158 45.3865)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#020101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#090305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#14070B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#250C14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#3B1420"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#571C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#772740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#9D3454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#C6416A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D84774"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_13_16353",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1111.85 589.889) rotate(-161.746) scale(36.1597 35.5553)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#020101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#090305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#14070B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#250C14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#3B1420"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#571C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#772740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#9D3454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#C6416A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D84774"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_13_16353",
    x1: 1138.14,
    y1: 549.859,
    x2: 1113,
    y2: 584.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3DD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#2E3192"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00007A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_13_16353",
    x1: 1144.89,
    y1: 555.708,
    x2: 1112.81,
    y2: 561.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3DD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#2E3192"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00007A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_13_16353",
    x1: 1134.36,
    y1: 602.228,
    x2: 1096.58,
    y2: 620.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3DD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#2E3192"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00007A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_13_16353",
    x1: 481.254,
    y1: 274.762,
    x2: 520.488,
    y2: 383.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#030101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#0E0502"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#1F0C05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#381508"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#58210D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65260F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_13_16353",
    x1: 104.115,
    y1: 17.9707,
    x2: 127.381,
    y2: 85.4624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#030101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#0E0502"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#1F0C05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#381508"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#58210D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65260F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_13_16353",
    x1: 326.458,
    y1: 527.174,
    x2: 326.458,
    y2: 802.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5280F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#011B77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_13_16353",
    x1: 326.458,
    y1: 527.174,
    x2: 326.458,
    y2: 802.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F80FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0028B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_13_16353",
    x1: 424.496,
    y1: 919.325,
    x2: 424.496,
    y2: 1163.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5280F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#011B77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_13_16353",
    x1: 812.263,
    y1: 838.411,
    x2: 812.263,
    y2: 667.729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#090301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#220D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#4A1C0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#823013"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#C84B1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15A24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_13_16353",
    x1: 812.261,
    y1: 1012.74,
    x2: 812.261,
    y2: 743.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#090301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#220D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#4A1C0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#823013"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#C84B1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15A24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_13_16353",
    x1: 811.486,
    y1: 697.444,
    x2: 811.486,
    y2: 547.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FCEE21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FBB03B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FBAE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F6812E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#F26527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15A24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_13_16353",
    x1: 811.483,
    y1: 653.303,
    x2: 811.483,
    y2: 546.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FCEE21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FBB03B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FBAE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F6812E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#F26527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15A24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_13_16353",
    x1: 932.972,
    y1: 386.091,
    x2: 955.02,
    y2: 391.481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDD4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3174F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_13_16353",
    x1: 932.955,
    y1: 494.892,
    x2: 955.622,
    y2: 506.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDD4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3174F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_13_16353",
    x1: 684.753,
    y1: 386.091,
    x2: 706.801,
    y2: 391.481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDD4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3174F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_13_16353",
    x1: 691.106,
    y1: 537.738,
    x2: 668.439,
    y2: 526.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDD4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3174F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_13_16353",
    x1: 800.415,
    y1: 33.0139,
    x2: 891.617,
    y2: 50.6683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDD4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3174F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_13_16353",
    x1: 791.387,
    y1: 468.293,
    x2: 830.644,
    y2: 537.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDD4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3174F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_13_16353",
    x1: 797.06,
    y1: 512.057,
    x2: 826.509,
    y2: 564.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDD4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3174F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_13_16353",
    x1: 787.713,
    y1: 315.439,
    x2: 831.761,
    y2: 393.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4579DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#4B82E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#4D83E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3971DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_13_16353",
    x1: 349.951,
    y1: 883.599,
    x2: 349.951,
    y2: 1004.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F763AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D84774"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_13_16353",
    x1: 362.394,
    y1: 907.186,
    x2: 334.521,
    y2: 991.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D847AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF008F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_13_16353",
    x1: 307.724,
    y1: 952.182,
    x2: 377.825,
    y2: 916.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D847C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF008F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_13_16353",
    x1: 311.092,
    y1: 988.236,
    x2: 387.652,
    y2: 960.444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D847D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF008F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_13_16353",
    x1: 350.444,
    y1: 884.587,
    x2: 350.444,
    y2: 1004.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76398"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D84774"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_16353"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1247,
    height: 1075,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignUpImage);
export default __webpack_public_path__ + "static/media/signUpImage.9a968dc57f2abde81845cb7bf349749a.svg";
export { ForwardRef as ReactComponent };